module.exports = __webpack_public_path__ + "img/icon_all_selected.bd679004.svg";